const SCHEDULE_SCALES = ['large', 'medium', 'small']
const SCHEDULE_COLUMN_KEYS = ['position', 'workHours', 'contacts', 'warnings']

const defaultState = () => ({
  scheduleScale: 'large',
  visibleScheduleColumns: [...SCHEDULE_COLUMN_KEYS],
})

export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    scheduleScale: (s) => s.scheduleScale,
    visibleScheduleColumns: (s) => s.visibleScheduleColumns,
    isScheduleColumnVisible: (s) => (key) => s.visibleScheduleColumns.includes(key),
  },
  mutations: {
    setScheduleScale(state, value) {
      if (!SCHEDULE_SCALES.includes(value)) return
      state.scheduleScale = value
    },
    setVisibleScheduleColumns(state, value) {
      if (!Array.isArray(value)) return
      state.visibleScheduleColumns = value.filter((k) => SCHEDULE_COLUMN_KEYS.includes(k))
    },
    hydrate(state, payload) {
      if (!payload || typeof payload !== 'object') return
      if (SCHEDULE_SCALES.includes(payload.scheduleScale)) {
        state.scheduleScale = payload.scheduleScale
      }
      if (Array.isArray(payload.visibleScheduleColumns)) {
        state.visibleScheduleColumns = payload.visibleScheduleColumns.filter((k) =>
          SCHEDULE_COLUMN_KEYS.includes(k)
        )
      }
    },
  },
}

export { SCHEDULE_SCALES, SCHEDULE_COLUMN_KEYS }
